import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--navy)', textAlign: 'center', padding: '2rem' }}>
      <div>
        <div style={{ fontFamily: '"Bebas Neue"', fontSize: 'clamp(6rem, 20vw, 12rem)', color: 'var(--orange)', lineHeight: 1, opacity: 0.3 }}>404</div>
        <h1 style={{ fontFamily: '"Bebas Neue"', fontSize: 'clamp(2rem, 5vw, 3.5rem)', color: 'white', letterSpacing: '0.03em', marginBottom: '1rem' }}>
          Part Not Found
        </h1>
        <p style={{ color: 'var(--silver)', fontSize: '1.05rem', lineHeight: 1.6, maxWidth: 420, margin: '0 auto 2.5rem' }}>
          Looks like this page got sent to the crusher. Let's get you back on the road.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="btn-primary">🏠 Back to Home</Link>
          <Link to="/inventory" className="btn-outline">🔍 Search Parts</Link>
        </div>
      </div>
    </div>
  );
}
